import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const eventDelayUiNodeSpec: NodeSpec<NodeCfg<'eventDelay'>> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { delayMs: 1000 }, id: getUID(), kind: 'eventDelay', disabled: false }),
    controls: nodeCfg => ({
        delayMs: defineControlOpts({
            cfg: { kind: 'number', label: 'Delay (ms)', min: 0 },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.delayMs,
        }),
    }),
    inputs: () => ({ input: { socket: 'event', label: 'Input' } }),
    kindLabel: 'Event Delay',
    nodeCategory: 'events',
    outputs: () => ({ output: { socket: 'event', label: 'Output' } }),
    validator: () => true,
};
